import { render, staticRenderFns } from "./TallyBookPopup.vue?vue&type=template&id=45e4975e&scoped=true&"
import script from "./TallyBookPopup.vue?vue&type=script&lang=js&"
export * from "./TallyBookPopup.vue?vue&type=script&lang=js&"
import style0 from "./TallyBookPopup.vue?vue&type=style&index=0&id=45e4975e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e4975e",
  null
  
)

export default component.exports